import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';
import ProgressiveImage from 'react-progressive-image';

import global from '../../stores/GlobalStore';
import history from '../../auth/history';
import placeholder from '../../styles/images/placeholder.jpg';

import getCategories, { getTopCategories } from '../../data/categories';
import SearchBar from '../SearchBar/SearchBar';
import UserFollows from '../FeaturedLists/UserFollows';
import TopShows from '../FeaturedLists/TopShows';
import ByGenre from '../FeaturedLists/ByGenre';
import Background from '../../styles/images/sm-bg.jpg';
import Auth from '../../auth/auth';

import './styles/TimelinePage.scss';
import './styles/ShowsLandingPage.scss';
import 'react-activity-feed/dist/index.css';

export default class ShowsLandingPage extends React.Component {
  constructor(props) {
    super(props);

    this.PodcastStore = global().getPodcastStore();

    this.state = {
      isLoading: true,
      topShows: {
        createdAt: 1561899833089,
        createdBy: 'd9571238',
        description: 'Top Podcast shows for the week of June 30th',
        hashKey: 'PLAYLIST:TOP_SHOWS:06302019',
        items: [
          'c346ea62',
          '4bf4f892',
          'e4a62855',
          '8588efd0',
          'dd9cdb0c',
          '53c87570',
          '1f80cd9a',
          'b26c911e',
          'dd9cdb0c',
          '0654c00b',
        ],
        keywords: ['Top Podcasts', 'Top Shows', 'Featured'],
        lastUpdatedBy: 'd9571238',
        title: 'Top Shows',
        type: 'PLAYLIST',
        updatedAt: 1561899833089,
        uuid: 'TOP_SHOWS:06302019',
      },
      queryResults: [],
      genres: this.getUserGenres(),
    };
  }

  queryShowsAndEpisodes = query => {
    this.setState({ isLoading: true });

    if (!query) {
      this.setState({ queryResults: [], isLoading: false });
    }

    this.PodcastStore.queryShowsAndEpisodes(query, 0, 10, 'asc', results => {
      this.setState({ queryResults: results, isLoading: false });
    });
  };

  getUserGenres = () => {
    const auth = new Auth();
    const user = auth.isAuthenticated() ? global().getUserStore().getUserFromLocalStorage() : null;

    if (user && user.categories && user.categories.length) {
      let genres = getCategories();
      return user.categories.map(genre => {
        return genres[genre].title;
      });
    } else {
      return getTopCategories();
    }
  };

  navToShow = showId => {};

  renderShows = shows => {
    return Object.keys(shows).map(showId => {
      const show = shows[showId];
      const image =
        show.images && show.images.medium
          ? show.images.medium
          : show.images && show.images.thumbnail
          ? show.images.thumbnail
          : show.imageUrl;

      if (show.imageUrl) {
        return (
          <div className='show-container' key={show.id}>
            <a href={`/${show.id}`}>
              <ProgressiveImage src={image} placeholder={placeholder}>
                {(src, loading) => (
                  <img src={src} width={120} className={`show-image`} style={{ opacity: loading ? 0.6 : 1 }} alt='' />
                )}
              </ProgressiveImage>
              <div className='show-title'>{show.title}</div>
            </a>
          </div>
        );
      } else {
        return <div className='show-container' key={showId} style={{ display: 'none' }} />;
      }
    });
  };

  getQueryResults = () => {
    if (this.state.queryResults.length) {
      return this.state.queryResults;
    } else if (false) {
      // Get Google Trends from backend?
      return [
        {
          id: '',
          title: 'default list',
          description: 'default list',
          type: 'TRENDING',
        },
      ];
    }
  };

  toggleLoginModal = () => {
    window.dispatchEvent(new CustomEvent('OPEN_LOGIN_MODAL', { detail: {} }));
  };

  navTo = (link, e) => {
    e.stopPropagation();
    history.push(link);
  };

  renderPodapaloozaBanner = () => {
    const banner = 'https://schoon-images.s3-us-west-2.amazonaws.com/clipps/Podapalooza.png';
    return (
      <>
        <a href='https://www.podapalooza.org' target='_blank' rel='noopener noreferrer'>
          <div className='cta-container' style={{ width: '90%' }}>
            <div
              style={{
                position: 'relative',
                margin: '-10px auto 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <img src={banner} alt='Podapalooza Festival Banner' style={{ width: '100%' }} />
              <div style={{ position: 'absolute', bottom: '15px', right: '15px' }}>
                <a href='https://glow.fm/podapalooza/' target='_blank' rel='noopener noreferrer'>
                  <button className='raf-button'>Donate!</button>
                </a>
              </div>
            </div>
          </div>
        </a>
      </>
    );
  };

  renderCtas = user => {
    const userHasCategories = !!(user && user.categories);

    return (
      <>
        {userHasCategories ? (
          <a href={`/u/${user.id}?t=categories`}>
            <div className='cta-container' style={{ background: `url(${Background})`, width: '45%' }}>
              <div className='background-fade'>Update your categories</div>
            </div>
          </a>
        ) : (
          <div
            className='cta-container'
            onClick={this.toggleLoginModal}
            style={{ background: `url(${Background})`, width: '45%' }}
          >
            <div className='background-fade'>Create an account</div>
          </div>
        )}
        <a href='/community' rel='noopener noreferrer'>
          {' '}
          {/* eslint-disable-line */}
          <div className='cta-container' style={{ background: `url(${Background})`, width: '45%' }}>
            <div className='background-fade'>Join the Community</div>
          </div>
        </a>
      </>
    );
  };

  render() {
    const { topShows, genres } = this.state;
    const { darkMode, user } = this.props;

    return (
      <div className='user-feed'>
        <div className='mainPanel' ref='mainPanel' style={{ background: darkMode ? 'rgb(9, 16, 52)' : '' }}>
          <div
            className='show-list-container'
            style={{
              background: darkMode ? 'rgb(11, 19, 61)' : '',
              borderLeft: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
              borderRight: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <h1 style={{ fontSize: '24px', margin: '15px 0 0' }}>Welcome to Clipps</h1>
              <h2 style={{ fontSize: '18px', margin: '5px 0' }}>A podcast discovery service</h2>
            </div>
            <SearchBar
              queryShowsAndEpisodes={this.queryShowsAndEpisodes}
              fetching={this.state.isLoading}
              data={this.getQueryResults()}
            />
            <div className='show-list'>
              {user && <UserFollows userId={user.id} navToShow={this.navToShow} renderShows={this.renderShows} />}
              {topShows && (
                <LazyLoad height={280} offset={1000}>
                  <TopShows playlist={topShows} navToShow={this.navToShow} renderShows={this.renderShows} />
                </LazyLoad>
              )}
              <LazyLoad height={180} offset={1000}>
                {this.renderCtas(user)}
              </LazyLoad>
              {genres.map((genre, index) => {
                return (
                  <LazyLoad height={280} offset={1000} key={index}>
                    <ByGenre genre={genre} navToShow={this.navToShow} renderShows={this.renderShows} />
                  </LazyLoad>
                );
              })}
              {!user && this.renderCtas(user)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ShowsLandingPage.propTypes = {
  user: PropTypes.object,
  darkMode: PropTypes.bool,
};
